"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/RSFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_196)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_196`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.32001 -0.000244141H31.68V24H-4.32001V-0.000244141Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.32001 -0.000244141H31.68V7.99957H-4.32001V-0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.32001 15.9995H31.68V23.9993H-4.32001V15.9995Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.78322 6.78223V12.7684C4.78322 16.1735 9.23168 17.2168 9.23168 17.2168C9.23168 17.2168 13.68 16.1734 13.68 12.7684V6.78223H4.78322Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.62302 7.8257H11.8403V5.73875L10.7968 6.26047L9.23154 4.69531L7.66646 6.26047L6.62302 5.73875V7.8257ZM12.6366 13.6017L9.24533 10.2105L5.85408 13.6017L6.96087 14.7085L9.24533 12.424L11.5298 14.7085L12.6366 13.6017Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.6366 10.4344H11.0543C11.1464 10.276 11.195 10.0961 11.195 9.91282C11.195 9.33654 10.7277 8.86938 10.1515 8.86938C9.75333 8.86938 9.40754 9.09242 9.23161 9.42035C9.05569 9.09249 8.70983 8.86938 8.31172 8.86938C7.7355 8.86938 7.26828 9.33654 7.26828 9.91282C7.26828 10.1031 7.32003 10.2809 7.40897 10.4344H5.85408C5.85408 11.0107 6.35604 11.4778 6.93225 11.4778H6.89752C6.89752 12.0541 7.36468 12.5213 7.94096 12.5213C7.94096 13.0315 8.30736 13.4555 8.79132 13.5462L7.96908 15.4025C8.37432 15.5673 8.8077 15.652 9.24519 15.6517C9.68267 15.652 10.1161 15.5673 10.5213 15.4025L9.69905 13.5462C10.183 13.4555 10.5494 13.0315 10.5494 12.5213C11.1257 12.5213 11.5929 12.0541 11.5929 11.4778H11.5581C12.1346 11.4778 12.6366 11.0107 12.6366 10.4344Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_196`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as RSFlag };
